import { IconButton, InputAdornment, TextField } from "@mui/material";
import { Search as SearchIcon } from "@mui/icons-material";

type Props = {
  value: string;
  onChange: (value: string) => void;
  pause?: () => void;
  resume?: () => void;
};

export const TextFieldSearchFilter = ({
  value,
  onChange,
  pause = () => {},
  resume = () => {},
}: Props) => {
  return (
    <TextField
      fullWidth
      label="Search"
      variant="outlined"
      size="small"
      margin="dense"
      value={value}
      onChange={(event) => {
        onChange(event?.target.value);
      }}
      onFocus={pause}
      onBlur={resume}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <IconButton edge="start" type="submit">
                <SearchIcon />
              </IconButton>
            </InputAdornment>
          ),
        },
      }}
    />
  );
};
